export default __webpack_public_path__ + "static/media/international_pcr.96bd0b9d.svg";